var App = App || {};

App.WidgetResources = (function ($) {
    'use strict';

    function Init(widget) {
        InitScrollAnimations(widget);
        InitDimeParallax(widget);
    }

    function InitScrollAnimations(widget) {
        if (widget.hasClass("disable-animations")) {
            return;
        }

        if (typeof widget.ZagScrollAnimate !== "function") {
            return;
        }

        widget.ZagScrollAnimate({
            offset: 75,
            targets: [{ selector: ".resource-tip.shared-promo-card", type: "animate__fadeIn", stagger: 0 }],
            overflow: false
        });
    }

    function InitDimeParallax(widget) {
        const groups = widget.find(".resource-group").not(".resource-group--no-dime");

        if (!groups.length || widget.hasClass("widget--no-dime-bg")) {
            return;
        }

        const update = () => {
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            const viewportCenter = viewportHeight / 2;

            groups.each(function () {
                const rect = this.getBoundingClientRect();
                const groupCenter = rect.top + (rect.height / 2);
                const delta = viewportCenter - groupCenter;
                const dimeOffset = Clamp(delta * 0.04, -18, 18);

                this.style.setProperty("--resource-dime-offset", `${dimeOffset}px`);
            });
        };

        let ticking = false;
        const onScroll = () => {
            if (ticking) {
                return;
            }

            ticking = true;
            window.requestAnimationFrame(function () {
                update();
                ticking = false;
            });
        };

        update();
        window.addEventListener("scroll", onScroll, { passive: true });
        window.addEventListener("resize", onScroll);
    }

    function Clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
    }

    return {
        Init: Init
    };

}(jQuery));
